import { TextFieldProps } from '@material-ui/core';
import { FieldConfig, FieldProps } from 'formik';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField/TextField';

type Props = TextFieldProps & FieldConfig & FieldProps;

const CustomerTextareaField: FC<Props> = ({ field, ...rest }) => {
  const { t } = useTranslation();

  const error = useMemo(() => {
    const err = rest.form.errors[field.name];

    return err ? String(err) : '';
  }, [field, rest.form.errors]);

  return (
    <TextField error={!!error} multiline rows={4} helperText={t(error)} {...rest} {...field} />
  );
};

export default CustomerTextareaField;
